import { filter, find, get, head, indexOf, orderBy } from 'lodash';

export const filterByProp = (
  collection: Array<Object>,
  ids: Array<String>,
  prop: String = 'id',
  order?: String
) => {
  if (!collection || !collection.length) {
    return null;
  }
  const res = filter(collection, (item) => indexOf([].concat(ids), get(item, prop)) > -1);
  return order ? orderBy(res, order) : res;
};

export const findByProp = (collection: Array<Object>, id: String, prop: String = 'id') => {
  if (!collection || !collection.length) {
    return null;
  }
  return id ? find(collection, (item) => get(item, prop) === id) : head(collection);
};

export default {
  filterByProp,
  findByProp
};
